import React from "react";

function PrivacyPage() {
  return (
    <body style={{ margin: "auto", width: "calc(100% - 20px)", maxWidth: 700 }}>
      <h1>Informativa sulla privacy</h1>
      <p>Updated at 2023-05-15</p>

      <p>
        LaBraseria ("noi", "nostro" o "ci") si impegna a proteggere la vostra
        privacy. La presente Informativa sulla privacy illustra le modalità di
        raccolta, utilizzo e divulgazione dei vostri dati personali da parte di
        LaBraseria.
      </p>
      <p>
        La presente Informativa sulla privacy si applica al nostro sito web, e
        ai relativi sottodomini (collettivamente, il nostro "Servizio") insieme
        alla nostra applicazione, LaBraseria. Accedendo o utilizzando il nostro
        Servizio, l'utente dichiara di avere letto, compreso e accettato la
        raccolta, l'archiviazione, l'utilizzo e la informazioni personali come
        descritto nella presente Informativa sulla privacy e nei Termini di
        servizio. Informativa sulla privacy e nei nostri Termini di servizio.
      </p>

      <h1>Definizioni e termini chiave</h1>
      <p>
        Per aiutare a spiegare le cose nel modo più chiaro possibile in questa
        Informativa sulla privacy, ogni volta che si fa riferimento a uno
        qualsiasi di questi termini, sono rigorosamente definiti come:
        <ul>
          <li>
            Cookie: piccola quantità di dati generati da un sito web e salvati
            dal dal browser web. Viene utilizzato per identificare il browser,
            fornire analisi, memorizzare informazioni sull'utente, come ad
            esempio la lingua lingua o le informazioni di accesso.
          </li>
          <li>
            Azienda: quando in questa informativa si parla di "Azienda", "noi",
            "ci" o "nostro" si riferisce a La, Italia che è responsabile delle
            vostre informazioni ai sensi della presente Informativa sulla
            privacy.
          </li>
          <li>
            Paese: dove ha sede LaBraseria o i proprietari/fondatori de
            LaBraseria. in questo caso l'Italia.
          </li>
          <li>
            Cliente: si riferisce all'azienda, all'organizzazione o alla persona
            che sottoscrive utilizzare il Servizio LaBraseria per gestire i
            rapporti con i consumatori o gli utenti dei servizi. i propri
            consumatori o utenti del servizio.
          </li>
          <li>
            Dispositivo: qualsiasi dispositivo connesso a Internet come un
            telefono, un tablet, computer o qualsiasi altro dispositivo che
            possa essere utilizzato per visitare LaBraseria e utilizzare i
            servizi.
          </li>
          <li>
            Indirizzo IP: A ogni dispositivo connesso a Internet viene assegnato
            un numero numero noto come indirizzo di protocollo Internet (IP).
            Questi numeri sono di solito assegnati in blocchi geografici. Un
            indirizzo IP può spesso essere spesso può essere utilizzato per
            identificare la posizione da cui un dispositivo si connette a
            Internet. Internet.
          </li>
          <li>
            Personale: si riferisce a quegli individui che sono impiegati da
            LaBraseria o sono sotto contratto per eseguire un servizio per conto
            di una delle parti.
          </li>
          <li>
            Dati personali: qualsiasi informazione che direttamente,
            indirettamente, o in o in connessione con altre informazioni -
            compreso un numero di numero di identificazione personale - permette
            di identificare o identificabilità di una persona fisica.
          </li>
          <li>
            Servizio: si riferisce al servizio fornito da LaBraseria così come
            descritto nei relativi termini (se disponibili) e su questa
            piattaforma.
          </li>
          <li>
            Servizio di terze parti: si riferisce a inserzionisti, sponsor di
            concorsi, partner promozionali e di marketing e altri soggetti che
            forniscono i nostri contenuti o i cui prodotti o servizi riteniamo
            possano interessarvi.
          </li>
          <li>
            Sito web: Il sito de LaBraseria, accessibile tramite questo URL:
          </li>
          <li>
            Utente: persona o entità registrata presso LaBraseria per l'utilizzo
            dei Servizi. i Servizi.
          </li>
        </ul>
      </p>
      <h1>Quali informazioni raccogliamo?</h1>
      <p>
        Raccogliamo informazioni da voi quando visitate la nostra app, vi
        registrate sul nostro sito, fate un ordine, vi iscrivete alla nostra
        newsletter, rispondete ad un sondaggio. sito, effettua un ordine, si
        iscrive alla newsletter, risponde a un sondaggio o compila un modulo. o
        compilate un modulo.
      </p>

      <ul>
        <li>Nome / Nome utente</li>
        <li>Indirizzi e-mail</li>
        <li>Password</li>
      </ul>
      <ul></ul>

      <h1>Come utilizziamo le informazioni raccolte?</h1>
      <p>
        Tutte le informazioni raccolte possono essere utilizzate in uno dei
        seguenti modi modi seguenti:
        <ul>
          <li>
            Per personalizzare la vostra esperienza (le vostre informazioni ci
            aiutano a rispondere meglio alle vostre rispondere alle vostre
            esigenze individuali)
          </li>
          <li>
            Per migliorare la nostra applicazione (ci sforziamo continuamente di
            migliorare le nostre offerte offerte in base alle informazioni e al
            feedback che riceviamo da voi)
          </li>
          <li>
            Per migliorare il servizio clienti (le vostre informazioni ci
            aiutano a rispondere in modo più rispondere più efficacemente alle
            vostre richieste di assistenza e supporto esigenze di assistenza)
          </li>
          <li>Per elaborare le transazioni</li>
          <li>
            Per amministrare un concorso, una promozione, un sondaggio o
            un'altra funzione del sito
          </li>
          <li>Per inviare e-mail periodiche</li>
        </ul>
      </p>

      <h1>
        Quando LaBraseria utilizza le informazioni degli utenti finali
        provenienti da terzi?
      </h1>
      <p>
        LaBraseria raccoglierà i Dati dell'Utente finale necessari per fornire i
        servizi di LaBraseria ai propri clienti. LaBraseria ai propri clienti.
      </p>
      <p>
        Gli utenti finali possono fornirci volontariamente le informazioni che
        hanno reso disponibili sui siti web dei social media. Se l'utente ci
        fornisce tali informazioni, possiamo raccogliere le informazioni
        disponibili al pubblico dai siti di siti web dei social media indicati
        dall'utente. L'utente può controllare la quantità di informazioni
        dell'utente rese pubbliche dai siti web dei social media, visitando
        questi siti web e modificando le impostazioni sulla privacy.
      </p>

      <h1>
        Quando LaBraseria utilizza le informazioni dei clienti provenienti da
        terzi?
      </h1>
      <p>
        Riceviamo alcune informazioni da terzi quando ci contattate. Ad esempio,
        quando l'utente ci invia il proprio indirizzo e-mail per manifestare
        interesse cliente di LaBraseria, riceviamo informazioni da una terza
        parte che fornisce servizi di che fornisce servizi di rilevamento
        automatico delle frodi a LaBraseria. Noi occasionalmente raccogliamo
        anche informazioni rese disponibili pubblicamente sui siti di siti web
        di social media. L'utente può controllare quante delle sue informazioni
        siti web di social media rendono pubbliche visitando questi siti web e
        modificando le impostazioni sulla privacy.
      </p>

      <h1>Condividiamo le informazioni raccolte con terzi?</h1>
      <p>
        Possiamo condividere le informazioni che raccogliamo, sia personali che
        non personali, con terze parti come inserzionisti, sponsor di concorsi,
        partner promozionali e di marketing, e altri soggetti che ci forniscono
        i nostri contenuti o i cui prodotti o servizi riteniamo possano
        interessarvi. Potremmo anche condividere i dati con le nostre società
        affiliate attuali e future e con i partner commerciali partner
        commerciali e, qualora fossimo coinvolti in una fusione, vendita di
        attività o altre riorganizzazione aziendale, potremmo anche condividere
        o trasferire le vostre informazioni personali e informazioni non
        personali ai nostri successori.
      </p>
      <p>
        Possiamo incaricare fornitori di servizi terzi di fiducia di svolgere
        funzioni e fornire servizi, come l'hosting e la manutenzione dei nostri
        server e della e l'applicazione, l'archiviazione e la gestione dei
        database, la gestione della posta elettronica, l'archiviazione
        marketing, elaborazione delle carte di credito, assistenza clienti ed
        evasione di ordini di prodotti e servizi che l'utente può acquistare
        tramite l'applicazione. Noi probabilmente condivideremo le vostre
        informazioni personali, ed eventualmente alcune informazioni non
        personali, con queste terze parti per consentire loro di svolgere questi
        servizi per noi e per voi.
      </p>
      <p>
        Possiamo condividere parte dei dati dei nostri file di log, compresi gli
        indirizzi IP, per fini analitici con terze parti, quali partner di
        analisi web, sviluppatori di applicazioni e reti pubblicitarie,
        sviluppatori di applicazioni e reti pubblicitarie. Se il vostro
        indirizzo IP viene condiviso, può essere utilizzato per stimare la
        posizione generale e altri dati tecnici come la velocità di connessione,
        se avete visitato l'app in un luogo condiviso e il tipo di dispositivo
        utilizzato. e il tipo di dispositivo utilizzato per visitare
        l'applicazione. Possono aggregare informazioni sulla nostra pubblicità e
        su ciò che l'utente vede nell'app e quindi fornire revisioni, ricerche e
        rapporti per noi e per i nostri inserzionisti. Potremmo anche divulgare
        informazioni personali e non personali a funzionari governativi o delle
        forze dell'ordine o a soggetti privati. se, a nostra esclusiva
        discrezione, lo riteniamo necessario o opportuno per rispondere a
        richieste di risarcimento, procedimenti legali (comprese le citazioni in
        giudizio), per proteggere i nostri diritti e interessi o quelli di
        un'altra persona. i nostri diritti e interessi o quelli di una terza
        parte, la sicurezza del pubblico o di qualsiasi persona, per prevenire o
        fermare qualsiasi attività illegale, non etica o attività legalmente
        perseguibili, o per ottemperare in altro modo alle ordinanze
        giudiziarie, alle leggi, alle norme e ai regolamenti applicabili.
      </p>

      <h1>
        Dove e quando vengono raccolte le informazioni dai clienti e dagli
        utenti finali?
      </h1>
      <p>
        LaBraseria raccoglierà le informazioni personali che l'utente ci
        invierà. LaBraseria informazioni personali da terzi, come descritto
        sopra. come descritto sopra.
      </p>

      <h1>Come utilizziamo il vostro indirizzo e-mail?</h1>
      <p>
        Inviando il proprio indirizzo e-mail su questa applicazione, l'utente
        accetta di ricevere e-mail da parte nostra. È possibile annullare la
        propria partecipazione a uno qualsiasi di questi elenchi liste di e-mail
        in qualsiasi momento facendo clic sul link di rinuncia o su un'altra
        opzione di annullamento dell'iscrizione opzione di cancellazione inclusa
        nella rispettiva e-mail. Inviamo e-mail solo a persone che ci hanno
        autorizzato a contattarle, direttamente o attraverso una terza parte.
        Non inviamo e-mail commerciali non richieste, perché odiamo lo spam
        tanto quanto voi. Inviando il vostro indirizzo e-mail l'indirizzo di
        posta elettronica, accettate anche di consentirci di utilizzare il
        vostro indirizzo di posta elettronica per il targeting del pubblico su
        siti come Facebook, dove visualizziamo pubblicità personalizzata a
        persone specifiche che hanno scelto di ricevere comunicazioni da parte
        nostra. Gli indirizzi e-mail inviati solo attraverso la pagina di pagina
        di elaborazione dell'ordine saranno utilizzati al solo scopo di inviarle
        informazioni e aggiornamenti relativi al vostro ordine. Tuttavia, se
        l'utente ha fornito lo stesso indirizzo e-mail attraverso un altro
        metodo, possiamo utilizzarlo per qualsiasi scopo indicato nella presente
        Politica. Nota: Se in qualsiasi momento si desidera desideri annullare
        l'iscrizione alla ricezione di future e-mail, includeremo istruzioni
        dettagliate per l'annullamento dell'iscrizione in fondo a ogni e-mail.
      </p>

      <h1>Per quanto tempo conserviamo le vostre informazioni?</h1>
      <p>
        Se conserviamo le informazioni dell'utente solo per il tempo necessario
        a fornire LaBraseria all'utente e adempiere agli scopi descritti nella
        presente informativa. Questo vale anche per tutti coloro con cui
        condividiamo le informazioni dell'utente e che che svolgono servizi per
        nostro conto. Quando non abbiamo più bisogno di utilizzare le
        informazioni dell'utente e non è necessario conservarle per adempiere ai
        obblighi legali o normativi, le rimuoveremo dai nostri sistemi o le
        spersonalizzeremo in modo da sistemi o le spersonalizzeremo in modo da
        non potervi identificare.
      </p>

      <h1>Come proteggiamo le vostre informazioni?</h1>
      <p>
        Implementiamo una serie di misure di sicurezza per mantenere la
        sicurezza delle delle vostre informazioni personali quando effettuate un
        ordine o inserite, inviate o accedere alle informazioni personali.
        Offriamo l'uso di un server sicuro. Tutte le informazioni
        sensibili/creditizie fornite vengono trasmesse tramite la tecnologia
        Secure Socket Layer (SSL) e quindi crittografate nel database dei nostri
        fornitori di gateway di pagamento. fornitori di gateway di pagamento per
        essere accessibili solo a coloro che sono autorizzati con diritti di
        accesso speciali a tali sistemi, e sono tenuti a mantenere le
        informazioni informazioni riservate. Dopo una transazione, le
        informazioni private (carte di credito, numeri di previdenza sociale,
        dati finanziari, ecc. in archivio. Tuttavia, non possiamo assicurare o
        garantire la sicurezza assoluta di informazioni trasmesse a LaBraseria,
        né possiamo garantire che le vostre informazioni sul Servizio non siano
        accessibili, divulgate, alterate o distrutte da una violazione di uno
        qualsiasi dei distrutte da una violazione di una qualsiasi delle nostre
        protezioni fisiche, tecniche o gestionali. salvaguardia.
      </p>

      <h1>Le mie informazioni possono essere trasferite in altri Paesi?</h1>
      <p>
        LaBraseria ha sede in Italia. Le informazioni raccolte tramite il nostro
        sito web, attraverso interazioni dirette con l'utente, o dall'utilizzo
        dei nostri servizi di aiuto servizi di assistenza possono essere
        trasferite di volta in volta ai nostri uffici o al personale personale,
        o a terze parti, situati in tutto il mondo, e possono essere
        visualizzati e ospitati in qualsiasi parte del mondo, compresi i paesi
        che potrebbero non hanno leggi di applicabilità generale che regolano
        l'uso e il trasferimento di tali dati. di tali dati. Nella misura
        massima consentita dalla legge in vigore, utilizzando di quanto sopra,
        l'utente acconsente volontariamente al trasferimento transfrontaliero
        transfrontaliero e all'hosting di tali informazioni.
      </p>

      <h1>
        Le informazioni raccolte attraverso il Servizio LaBraseria sono sicure?
      </h1>
      <p>
        Prendiamo precauzioni per proteggere la sicurezza delle vostre
        informazioni. Disponiamo di procedure fisiche, elettroniche e
        manageriali per contribuire alla salvaguardia, impedire l'accesso non
        autorizzato, mantenere la sicurezza dei dati e utilizzare correttamente
        le le informazioni dell'utente. Tuttavia, né le persone né i sistemi di
        sicurezza sono infallibili, compresi i sistemi di crittografia. Inoltre,
        le persone possono commettere reati intenzionali, commettere errori o
        non seguire le politiche. Pertanto, pur compiendo sforzi ragionevoli per
        proteggere le informazioni personali degli utenti, non possiamo non
        possiamo garantirne l'assoluta sicurezza. Se la legge applicabile impone
        un obbligo non derogabile di protezione delle informazioni personali,
        l'utente accetta che la cattiva condotta intenzionale sarà lo standard
        utilizzato per misurare la nostra conformità a tale obbligo.
      </p>

      <h1>Posso aggiornare o correggere le mie informazioni?</h1>
      <p>
        I diritti dell'utente di richiedere aggiornamenti o correzioni alle
        informazioni raccolte dipendono dal suo rapporto con LaBraseria.
        LaBraseria raccoglie dipendono dal vostro rapporto con LaBraseria. Il
        personale può aggiornare o correggere le proprie informazioni come
        specificato nelle nostre politiche aziendali interne in materia di
        lavoro.
      </p>
      <p>
        I clienti hanno il diritto di richiedere la restrizione di determinati
        usi e divulgazione di informazioni di identificazione personale come
        segue. Il cliente per (1) aggiornare o correggere le proprie
        informazioni di identificazione personale, (2) modificare le proprie
        preferenze in materia di informazioni di identificazione personale, (2)
        modificare le proprie preferenze in merito a comunicazioni e altre
        informazioni che ricevete da noi, o (3) cancellare le informazioni di
        identificazione personale conservate sui nostri sistemi (soggetto a
        sistemi (fatto salvo il paragrafo seguente), cancellando il vostro
        account. Tali aggiornamenti, correzioni, modifiche e cancellazioni non
        avranno alcun effetto sulle altre informazioni da noi conservate o su
        quelle fornite a terzi in conformità alla presente Informativa sulla
        privacy prima di tali aggiornamenti, correzioni, modifiche o
        cancellazioni. Per proteggere la privacy e la sicurezza dell'utente,
        potremmo adottare misure ragionevoli (come la richiesta di una password
        unica) per verificare l'identità dell'utente prima di concedergli
        l'accesso al profilo o di effettuare correzioni. L'utente è responsabile
        del mantenimento della segretezza della propria password unica e delle
        informazioni relative al proprio account in qualsiasi momento.
      </p>
      <p>
        L'utente deve essere consapevole del fatto che non è tecnologicamente
        possibile eliminare ogni singola registrazione delle informazioni che ci
        avete fornito dal nostro sistema. dal nostro sistema. La necessità di
        eseguire il backup dei nostri sistemi per proteggere le informazioni da
        perdita involontaria significa che potrebbe esistere una copia delle
        informazioni dell'utente in una forma forma non cancellabile che sarà
        difficile o impossibile per noi individuare. Subito dopo aver ricevuto
        la richiesta, tutte le informazioni personali memorizzate nei database
        che utilizziamo attivamente nei database che utilizziamo attivamente e
        in altri supporti facilmente consultabili saranno aggiornati, corretti,
        modificati o cancellati, a seconda dei casi, non appena e nella misura
        in cui ciò sia ragionevolmente e tecnicamente possibile.
      </p>
      <p>
        Se siete un utente finale e desiderate aggiornare, cancellare o ricevere
        qualsiasi informazioni su di voi, potete farlo contattando
        l'organizzazione di cui siete clienti. organizzazione di cui è cliente.
      </p>
      <h1>Personale</h1>
      <p>
        Se siete un lavoratore o un richiedente de LaBraseria, raccogliamo le
        informazioni che voi volontariamente. Utilizziamo le informazioni
        raccolte per le Risorse Umane per amministrare i benefici ai lavoratori
        e vagliare i candidati. candidati.
      </p>
      <p>
        Potete contattarci per (1) aggiornare o correggere le vostre
        informazioni, (2) cambiare le proprie preferenze in merito alle
        comunicazioni e alle altre informazioni che ricevete da noi, o (3)
        ricevere una registrazione delle informazioni in nostro possesso
        relative all'utente. Tali aggiornamenti, correzioni, modifiche e
        cancellazioni non avranno alcun effetto su altre informazioni da noi
        conservate, o sulle informazioni che abbiamo fornito a terzi in
        conformità con la presente questa Informativa sulla privacy prima
        dell'aggiornamento, della correzione, della modifica o
        dell'eliminazione. cancellazione.
      </p>
      <h1>Vendita di un'attività commerciale</h1>
      <p>
        Ci riserviamo il diritto di trasferire le informazioni a una terza parte
        in caso di caso di vendita, fusione o altro trasferimento di tutti o
        sostanzialmente tutti i beni de LaBraseria o delle sue Affiliate (come
        definite). LaBraseria o di una delle sue Affiliate (come definite nel
        presente documento), o di una parte di LaBraseria o di una delle sue
        Affiliate (come definite nel presente documento). LaBraseria o di una
        delle sue Affiliate (come definite nel presente documento), o di quella
        parte di LaBraseria o di una delle sue Affiliate a cui il Servizio si
        riferisce. Affiliate a cui si riferisce il Servizio, o nel caso in cui
        noi cessiamo la nostra attività o presentiamo un'istanza o abbiamo
        presentato contro di noi una istanza di fallimento, di riorganizzazione
        o di un procedimento simile, a patto che che il terzo accetti di aderire
        ai termini della presente Informativa sulla privacy. Privacy.
      </p>

      <h1>Affiliati</h1>
      <p>
        Potremmo divulgare le informazioni (comprese quelle personali) che vi
        riguardano alle nostre società affiliate. Ai fini della presente
        Informativa sulla privacy, per "Affiliata aziendale" si intende
        qualsiasi persona o entità che direttamente o indirettamente controlla,
        è controllata da o è sotto controllo comune con LaBraseria, sia per
        proprietà che per altro. LaBraseria, sia per proprietà che per altro.
        Qualsiasi informazione relativa all'utente che forniamo alle nostre
        Affiliate Aziendali saranno trattate da tali Tali società affiliate
        saranno trattate in conformità con i termini della presente Informativa
        sulla privacy. Privacy.
      </p>

      <h1>Legge applicabile</h1>
      <p>
        La presente Informativa sulla privacy è disciplinata dalle leggi
        italiane senza tener conto di delle disposizioni in materia di conflitto
        di leggi. L'utente acconsente all'esclusiva giurisdizione dei tribunali
        in relazione a qualsiasi azione o controversia tra le parti ai sensi
        della presente Informativa sulla privacy o in relazione ad essa, fatta
        eccezione per i soggetti che possono avere il diritto di avanzare
        richieste di risarcimento. Privacy, fatta eccezione per gli individui
        che potrebbero avere il diritto di avanzare richieste di risarcimento ai
        sensi del Privacy Shield o del quadro normativo svizzero-americano.
      </p>
      <p>
        Il presente Contratto e l'utilizzo dell'applicazione da parte
        dell'utente sono disciplinati dalle leggi italiane, ad esclusione delle
        norme sui conflitti di legge. il presente Contratto e l'utilizzo
        dell'applicazione da parte dell'utente. L'utilizzo dell'applicazione da
        parte dell'utente potrebbe essere essere soggetto ad altre leggi locali,
        statali, nazionali o internazionali.
      </p>
      <p>
        Utilizzando LaBraseria o contattandoci direttamente, accettate la
        presente Informativa sulla privacy. Se non accettate la presente
        Informativa sulla privacy, non dovreste utilizzare il nostro sito web o
        i nostri servizi. L'uso continuato del sito web, l'impegno diretto con
        noi o la pubblicazione di modifiche alla presente Informativa sulla
        privacy che non incidono in modo significativo sull'uso o sulla
        divulgazione dei vostri dati personali implicheranno l'accettazione di
        tali modifiche.
      </p>

      <h1>Il vostro consenso</h1>
      <p>
        Abbiamo aggiornato la nostra Informativa sulla Privacy per fornirvi una
        completa trasparenza su ciò che viene impostato quando si visita il
        nostro sito e su come viene vengono utilizzati. Utilizzando la nostra
        applicazione, registrando un account o facendo un acquisto, l'utente
        acconsente alla nostra Informativa sulla privacy e ne accetta i termini.
        termini.
      </p>

      <h1>Link ad altri siti web</h1>
      <p>
        La presente Informativa sulla privacy si applica esclusivamente ai
        Servizi. I Servizi possono contenere link ad altri siti web non gestiti
        o controllati da LaBraseria. LaBraseria. Non siamo responsabili del
        contenuto, dell'accuratezza o delle opinioni espresse in tali siti web e
        tali siti web non sono da noi indagati, monitorati o controllati per
        quanto riguarda l'accuratezza o la completezza. Si ricorda che quando si
        utilizza un link per passare dai Servizi a un altro sito web, la nostra
        Informativa sulla privacy non è più in vigore. La navigazione e
        l'interazione dell'utente su qualsiasi altro sito web, compresi quelli
        che hanno un link sulla nostra piattaforma, è soggetta alle regole e
        alle politiche di quel sito web. Tali terze parti possono utilizzare i
        propri cookie o altri metodi per raccogliere informazioni sull'utente.
      </p>
      <h1>Cookies</h1>
      <p>
        LaBraseria utilizza i "cookie" per identificare le aree del nostro sito
        web che l'utente ha visitato. avete visitato. Un cookie è una piccola
        porzione di dati memorizzata sul computer o sul dispositivo mobile
        dell'utente o dispositivo mobile dal vostro browser web. Utilizziamo i
        cookie per migliorare le prestazioni e la funzionalità della nostra
        applicazione, ma non sono essenziali per il loro utilizzo. Tuttavia,
        senza questi cookie, alcune funzionalità come i video video potrebbero
        non essere disponibili o vi verrebbe richiesto di inserire i vostri dati
        di accesso ogni volta che visitate l'app. ogni volta che si visita
        l'applicazione, poiché non saremmo in grado di ricordare che l'utente ha
        effettuato l'accesso in precedenza. La maggior parte dei browser web può
        essere impostata per disabilitare l'uso dei cookie. Tuttavia, se
        disabilitate i cookie, potreste non essere in grado di l'utente potrebbe
        non essere in grado di accedere correttamente o del tutto alle
        funzionalità del nostro sito web. Noi non inseriamo mai informazioni di
        identificazione personale nei cookie.
      </p>

      <h1>Bloccare e disabilitare i cookie e tecnologie simili</h1>
      <p>
        Ovunque vi troviate, potete anche impostare il vostro browser in modo da
        bloccare i cookie e altre tecnologie simili. e tecnologie simili, ma
        questa azione potrebbe bloccare i nostri cookie essenziali e impedire il
        corretto funzionamento del nostro sito web. cookie essenziali e impedire
        al nostro sito web di funzionare correttamente, e potreste non essere in
        grado di non essere in grado di utilizzare appieno tutte le sue
        caratteristiche e i suoi servizi. L'utente Inoltre, l'utente deve essere
        consapevole del fatto che potrebbe perdere alcune informazioni salvate
        (ad es. dati di accesso salvati, preferenze del sito) se bloccate i
        cookie sul vostro browser. I diversi browser mettono a disposizione
        controlli diversi. La disabilitazione di un cookie o di una categoria di
        cookie non elimina il cookie dal browser. dal browser, è necessario
        farlo da soli all'interno del browser. browser; per ulteriori
        informazioni, consultare il menu di aiuto del browser.
      </p>
      <h1>Privacy dei bambini</h1>
      <p>
        Non ci rivolgiamo a persone di età inferiore ai 13 anni. Non raccogliamo
        consapevolmente raccogliere informazioni di identificazione personale da
        persone di età inferiore ai 13. Se siete un genitore o un tutore e siete
        a conoscenza del fatto che il vostro bambino ci ha fornito dati
        personali, siete pregati di contattarci. Se veniamo a conoscenza di aver
        raccolto dati personali da persone di età inferiore ai 13 anni senza 13
        anni senza la verifica del consenso dei genitori, ci attiviamo per
        eliminare tali informazioni dai nostri server.
      </p>
      <h1>Modifiche alla nostra politica sulla privacy</h1>
      <p>
        Potremmo cambiare il nostro Servizio e le nostre politiche e potremmo
        dover apportare modifiche alla presente Informativa sulla privacy in
        modo che rifletta accuratamente il nostro Servizio e le nostre
        politiche. alla presente Informativa sulla privacy in modo che rifletta
        accuratamente il nostro servizio e le nostre politiche. politiche. Se
        non diversamente richiesto dalla legge, vi informeremo (ad esempio,
        tramite il nostro Servizio) prima di apportare modifiche alla presente
        Informativa sulla privacy. ad esempio, attraverso il nostro Servizio)
        prima di apportare modifiche alla presente Informativa sulla privacy
        Privacy e vi daremo l'opportunità di rivederle prima che entrino in
        vigore. effettive. In seguito, se continuerete a utilizzare il Servizio,
        sarete vincolati dalle l'Informativa sulla privacy aggiornata. Se
        l'utente non vuole accettare questa o qualsiasi altra Informativa sulla
        privacy aggiornata, può cancellare il proprio account.
      </p>

      <h1>Servizi di terze parti</h1>
      <p>
        Possiamo visualizzare, includere o rendere disponibili contenuti di
        terzi (tra cui dati, informazioni, applicazioni e altri
        prodotti-servizi) o fornire link a siti web o servizi di terzi ("Servizi
        di terzi"). link a siti web o servizi di terzi ("Servizi di terzi").
      </p>
      <p>
        L'utente riconosce e accetta che LaBraseria non sarà responsabile per
        dei Servizi di Terze Parti, inclusa la loro accuratezza, completezza,
        tempestività, validità, conformità al copyright, legalità, decenza,
        qualità, tempestività, validità, conformità al diritto d'autore,
        legalità, decenza, qualità o qualsiasi altro aspetto degli stessi.
        LaBraseria non si assume e non avrà responsabilità nei confronti
        dell'utente o di qualsiasi altra persona o entità per i Servizi di
        terzi. persona o entità per qualsiasi Servizio di terze parti.
      </p>
      <p>
        I Servizi di terze parti e i relativi link sono forniti esclusivamente
        come comodità per l'utente e l'accesso e l'utilizzo di tali servizi
        avviene a proprio rischio e pericolo e in base ai termini e alle
        condizioni di tali terze parti.
      </p>
      <ul></ul>
      <h1>
        Informazioni sul Regolamento generale sulla protezione dei dati (GDPR)
      </h1>
      <p>
        Potremmo raccogliere e utilizzare le informazioni dell'utente se questi
        proviene dallo Spazio Economico Europeo (SEE), e in questa sezione della
        nostra Informativa sulla Privacy spiegheremo esattamente come e perché
        vengono raccolti questi dati e come manteniamo questi dati sotto
        protezione per evitare che vengano replicati o utilizzati in modo
        errato.
      </p>

      <h1>Che cos'è il GDPR?</h1>
      <p>
        Il GDPR è una legge sulla privacy e sulla protezione dei dati a livello
        europeo che regolamenta il modo in cui i dati dei residenti nell'UE
        vengono protetti dalle aziende e dell'Unione Europea siano protetti
        dalle aziende e aumenta il controllo che gli residenti nell'UE sui
        propri dati personali.
      </p>
      <p>
        Il GDPR è rilevante per qualsiasi azienda che opera a livello globale e
        non solo per le aziende con sede nell'UE e per i residenti nell'UE.
        aziende con sede nell'UE e ai residenti nell'UE. I dati dei nostri
        clienti sono importanti indipendentemente dalla loro ubicazione, ed è
        per questo che abbiamo implementato i controlli del controlli GDPR come
        standard di base per tutte le nostre attività in tutto il mondo.
      </p>

      <h1>Che cosa sono i dati personali? </h1>
      <p>
        Qualsiasi dato che si riferisce a un individuo identificabile o
        identificato. IL GDPR copre un ampio spettro di informazioni che
        potrebbero essere utilizzate da sole, o in combinazione con altre
        informazioni, per identificare una persona. I dati personali vanno oltre
        il nome o l'indirizzo e-mail di una persona. Alcuni esempi esempi sono
        le informazioni finanziarie, le opinioni politiche, i dati dati
        genetici, dati biometrici, indirizzi IP, indirizzi fisici, orientamento
        sessuale ed etnia. orientamento sessuale ed etnia.
      </p>
      <p>I principi di protezione dei dati includono requisiti come:</p>
      <ul>
        <li>
          I dati personali raccolti devono essere trattati in modo equo, legale
          e trasparente. trasparente e devono essere utilizzati solo nel modo in
          cui una persona si aspetterebbe ragionevolmente si aspetta.
        </li>
        <li>
          I dati personali devono essere raccolti solo per adempiere a uno scopo
          specifico e devono essere utilizzati solo per tale scopo. Le
          organizzazioni devono specificare il motivo per cui hanno bisogno dei
          dati personali quando li raccolgono.
        </li>
        <li>
          I dati personali non devono essere conservati più a lungo di quanto
          sia necessario per soddisfare le finalità.
        </li>
        <li>
          Le persone interessate dal GDPR hanno il diritto di accedere ai propri
          dati personali. dati personali. Possono inoltre richiedere una copia
          dei loro dati e che i loro dati siano essere aggiornati, cancellati,
          limitati o trasferiti a un'altra organizzazione.
        </li>
      </ul>

      <h1>Perché il GDPR è importante? </h1>
      <p>
        Il GDPR aggiunge alcuni nuovi requisiti in merito a come le aziende
        devono proteggere i dati personali degli individui che raccolgono ed
        elaborano. Inoltre alza la posta in gioco per la conformità, aumentando
        l'applicazione della normativa e imponendo maggiori multe più alte in
        caso di violazione. Al di là di questi fatti, è semplicemente la cosa
        giusta da fare. Noi di LaBraseria crediamo fermamente che la privacy dei
        vostri dati sia molto importante e disponiamo già di solide pratiche di
        sicurezza e privacy che che vanno oltre i requisiti di questa nuova
        normativa.
      </p>

      <h1>
        Diritti dell'interessato - Accesso, portabilità e cancellazione dei dati
      </h1>
      <p>
        Ci impegniamo ad aiutare i nostri clienti a soddisfare i diritti degli
        interessati requisiti del GDPR. LaBraseria elabora o memorizza tutti i
        dati personali in fornitori completamente controllati e conformi al DPA.
        Conserviamo tutte le conversazioni e i dati dati personali per un
        massimo di 6 anni, a meno che il vostro account non venga cancellato. In
        tal caso in tal caso, smaltiamo tutti i dati in conformità ai nostri
        Termini di servizio e alla nostra Privacy Policy, ma non li conserveremo
        per più di 60 giorni.
      </p>
      <p>
        Siamo consapevoli che se lavorate con clienti dell'Unione Europea,
        dovete essere in grado di fornire loro la possibilità di accedere,
        aggiornare, aggiornare, aggiornare e aggiornare i dati. clienti dell'UE,
        dovete essere in grado di fornire loro la possibilità di accedere,
        aggiornare, recuperare e rimuovere i dati personali. rimuovere i dati
        personali. Vi abbiamo fregati! Siamo stati impostati come self service
        fin dall'inizio e abbiamo sempre fin dall'inizio e vi abbiamo sempre
        dato accesso ai vostri dati e a quelli dei vostri clienti. clienti. Il
        nostro team di assistenza clienti è a vostra disposizione per rispondere
        a qualsiasi domande sull'utilizzo dell'API.
      </p>
      <h1>Contatti</h1>
      <p>Non esiti a contattarci per qualsiasi domanda.</p>
      <ul>
        <li>
          Via Email:{" "}
          <a
            href="/cdn-cgi/l/email-protection"
            class="__cf_email__"
            data-cfemail="780b0c1d1e1916170e110e19141c111611561c1d0e381f15191114561b1715"
          >
            [email&#160;protected]
          </a>
        </li>
      </ul>
      <script
        data-cfasync="false"
        src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"
      ></script>
    </body>
  );
}

export default PrivacyPage;
